module.exports = {
      id: "arrow-up-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#arrow-up",
      toString: function () {
        return this.url;
      }
    }